import { useContext, useEffect, useState } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import useDashboard from './useDashboard';

const SummaryCounts = () => {
    const { state } = useContext(SmartContext);
    const { getDashboardData } = useDashboard();

    useEffect(() => {
        getDashboardData();
    }, []);

    return (   
            <div className="col-12">
                <div className="row g-3">
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                        <div className="bg-grd-blue-619ECE-0B3454 p-3 rounded-3 shadow-sm text-white h-100">
                            <h3 className="font-35 font-600 mb-0">{state.data?.dashboardData?.dashboardCounts?.total_jobs || 0}</h3>
                            <p className="font-16 font-500 mb-0">Total Jobs
                                Posted</p>
                            {/* <span className="font-14 font-400 mb-0"><i className="bi bi-arrow-up "></i> 1 this
                                month</span> */}
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                        <div className="bg-grd-blue-619ECE-0B3454 p-3 rounded-3 shadow-sm text-white h-100">
                            <h3 className="font-35 font-600 mb-0">{state.data?.dashboardData?.dashboardCounts?.applications || 0}</h3>
                            <p className="font-16 font-500 mb-0">Total
                                Applications</p>
                            {/* <span className="font-14 font-400 mb-0"><i className="bi bi-arrow-up "></i> 5 this
                                week</span> */}
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                        <div className="bg-grd-blue-619ECE-0B3454 p-3 rounded-3 shadow-sm text-white h-100">
                            <h3 className="font-35 font-600 mb-0">{state.data?.dashboardData?.dashboardCounts?.interested || 0}</h3>
                            <p className="font-16 font-500 mb-0">Interested
                                Users</p>
                            {/* <span className="font-14 font-400 mb-0"><i className="bi bi-arrow-up "></i> 8 this
                                week</span> */}
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-3 col-6">
                        <div className="bg-grd-blue-619ECE-0B3454 p-3 rounded-3 shadow-sm text-white h-100">
                            <h3 className="font-35 font-600 mb-0">{state.data?.dashboardData?.dashboardCounts?.views || 0}</h3>
                            <p className="font-16 font-500 mb-0">Total Views</p>
                            {/* <span className="font-14 font-400 mb-0"><i className="bi bi-arrow-up "></i> 156 this
                                week</span> */}
                        </div>
                    </div>
                </div>
            </div>
            
    );
};

export default SummaryCounts;